import { Component, type ReactNode } from 'react';

import { reportCrash } from '@/lib/crashReporter';

/**
 * BlockBoundary — isolates a single block's render so a malformed / empty
 * content payload (common while an admin is still filling a freshly-added
 * block) cannot crash the whole builder canvas or player. On error it shows
 * `fallback` instead. Resets automatically when `resetKey` changes (e.g. the
 * block content was edited), so a fixed block re-renders live.
 */
export class BlockBoundary extends Component<
  { children: ReactNode; fallback: ReactNode; resetKey?: unknown },
  { failed: boolean }
> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  // Заглушка спасает урок, но падение блока — дефект: в приложении уходит отчётом (T23).
  componentDidCatch(error: unknown) {
    reportCrash('js-error', error);
  }

  componentDidUpdate(prev: { resetKey?: unknown }) {
    if (prev.resetKey !== this.props.resetKey && this.state.failed) {
      this.setState({ failed: false });
    }
  }

  render() {
    return this.state.failed ? this.props.fallback : this.props.children;
  }
}
